import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg
      height={height}
      width={width}
      {...props}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_569_498)">
        <path
          d="M14.6668 7.99992C14.6668 11.6818 11.682 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.682 1.33325 14.6668 4.31802 14.6668 7.99992Z"
          stroke="#637381"
        />
        <path
          d="M9.80696 6.70732C9.74089 6.19888 9.15709 5.3774 8.10736 5.37738C6.88763 5.37736 6.3744 6.05289 6.27026 6.39066C6.10779 6.84245 6.14029 7.77132 7.56996 7.87258C9.35709 7.99925 10.073 8.21018 9.98196 9.30392C9.89083 10.3976 8.89463 10.6339 8.10736 10.6085C7.32003 10.5832 6.03192 10.2216 5.98193 9.24878M7.98243 4.66528V5.3798M7.98243 10.602V11.3319"
          stroke="#637381"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_569_498">
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgComponent
